import { SubscriptionFlowDetails } from '../../../flow/serverApi/types/SubscriptionFlow';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface CreateSubscriptionsParams {
  readonly scheduleId: string;
  readonly subject: string;
  readonly userIds: string[];
  readonly groupIds: string[];
  readonly targetType: string;
  readonly targetId: string;
  readonly subscriptionMessage: string;
  readonly subscriptionFlowDetails: SubscriptionFlowDetails;
}

export class CreateSubscriptionsRequest extends Request<CreateSubscriptionsParams, IResult> {
  constructor(params: CreateSubscriptionsParams) {
    super('createSubscriptions', params);
  }
}
